import React, {useEffect, useState} from 'react';
import {Layout, Menu, Dropdown, Avatar, Tooltip} from 'antd';
import {MenuOutlined, LogoutOutlined} from '@ant-design/icons';
import {Link, useLocation} from 'react-router-dom';

import {
    getUserFromToken,
    isAuthenticated,
    removeToken
} from '../../data/storage';
import {getPages} from '../../data/pages';
import {fetchUserBydId} from '../../api/user';

import TokenPayload from '../../types/TokenPayload';
import User from '../../types/User';
import Page from '../../types/Page';
import {useTexts} from '../../hooks/useTexts';
import UserRole from '../../types/UserRole';

import './style.css';

const {Header} = Layout;

const Navbar = () => {
    const {t} = useTexts();
    const location = useLocation();
    const currentPath = location.pathname;

    const [user, setUser] = useState<User>({
        id: 0,
        username: '',
        firstname: '',
        lastname: '',
        roles: [],
        cities: [],
        products: [],
        active: true,
        lastSeenAt: null
    });

    useEffect(() => {
        const tokenPayload: TokenPayload | null = getUserFromToken();
        if (tokenPayload?.userId) {
            fetchUserBydId(tokenPayload.userId)
                .then((response) => {
                    if (response) setUser(response);
                })
                .catch((err) => console.error('ERROR', err));
        }
    }, []);

    const tokenPayload: TokenPayload | null = getUserFromToken();
    const isManager = tokenPayload?.roles?.some(role => role.id === UserRole.MANAGER) ?? false;

    const MANAGER_BLOCKED_PATHS = ['/mediators', '/mediators/scores'];

    const getFilteredPages = (): Page[] => {
        const pages = getPages() ?? [];
        if (isManager) {
            return pages.filter(page => !MANAGER_BLOCKED_PATHS.includes(page.path));
        }
        return pages;
    };

    const logout = () => {
        removeToken();
        window.location.href = '/login';
    };

    const navItems = getFilteredPages().map(page => ({
        key: page.path,
        label: <Link to={page.path}>{t('navigation', page.name)}</Link>
    }));

    const userMenuItems = [
        {
            key: 'logout',
            label: <span onClick={logout}>{t('auth', 'logout')}</span>,
            icon: <LogoutOutlined/>
        }
    ];

    const userInitials = (user.firstname?.[0]?.toUpperCase() || '') + (user.lastname?.[0]?.toUpperCase() || '');

    return (
        <Header className="app-navbar" style={{display: 'flex', alignItems: 'center'}}>
            <div className="mobile-menu-trigger">
                <Dropdown
                    menu={{items: navItems, selectedKeys: [currentPath]}}
                    trigger={['click']}
                    placement="bottomLeft"
                >
                    <MenuOutlined style={{color: 'white', fontSize: '20px', cursor: 'pointer'}}/>
                </Dropdown>
            </div>

            <div className="desktop-menu">
                <Menu
                    theme="dark"
                    mode="horizontal"
                    selectedKeys={[currentPath]}
                    items={navItems}
                    style={{flex: 1, minWidth: 0}}
                />
            </div>

            {isAuthenticated() && (
                <div style={{flexGrow: 0, display: 'flex', alignItems: 'center', marginLeft: '16px'}}>
                    <Dropdown menu={{items: userMenuItems}} trigger={['click']} placement="bottomRight">
                        <Avatar
                            style={{backgroundColor: 'rgba(255,255,255,0.2)', cursor: 'pointer'}}
                        >
                            {userInitials}
                        </Avatar>
                    </Dropdown>
                </div>
            )}
        </Header>
    );
};

export default Navbar;
